module.exports = __webpack_public_path__ + "static/media/Avatar_2.e948476b.svg";